<div [ngClass]="containerClass">
    <label [ngClass]="labelClass" [for]="id">{{label}}</label>
    <div [ngClass]="inputClass">
        <p [ngClass]="textClass" class="mb-0" [id]="id">{{text ? text: nullMessage}}</p>
    </div>
</div>